import React, { useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { CardSpaceWrapper, TranformButton } from '../../../components';
import { useMessageById } from '../../../hooks';
import styles from './style/index.less';
import { useReportService } from './useReportService';
import DiseaseModal from './DiseaseModal';
import { DiseaseTabs } from './DiseaseTabs';
var DiseaseCard = function (props) {
    var messageId = props.messageId;
    var messageState = useMessageById(messageId);
    var _a = messageState.payload, _b = _a.content, content = _b === void 0 ? {} : _b, recommendMode = _a.recommendMode, nerMode = _a.nerMode;
    var _c = useComponents(), View = _c.View, Image = _c.Image;
    var _d = useState(false), showModal = _d[0], setShowModal = _d[1];
    var _e = useState('overview'), diseaseTab = _e[0], setDiseaseTab = _e[1];
    var report = useReportService({ content: content, recommendMode: recommendMode, nerMode: nerMode, currentTab: diseaseTab });
    var onShowDetail = function () {
        report.diseaseClick();
        setShowModal(true);
    };
    var onChangeDiseaseTab = function (val) {
        setDiseaseTab(val);
    };
    return (React.createElement(View, { id: "card_" + content.id },
        React.createElement(CardSpaceWrapper, { className: styles['disease-card'], onClick: onShowDetail },
            React.createElement(View, { className: styles['disease-head-container'] },
                React.createElement(View, { className: styles['head-title'] },
                    React.createElement(View, null, content.name),
                    React.createElement(View, { className: styles.desc }, "\u75BE\u75C5\u5185\u5BB9\u7531\u5BFB\u533B\u95EE\u836F\u63D0\u4F9B")),
                React.createElement(Image, { className: styles['arrow-right'], imageWidth: 13, imageHeight: 13, src: "//leads.gdtimg.com/qzone/biz/gdt/fmc_consult/images/arrow-right.png" })),
            React.createElement(DiseaseTabs, { disease: content, currentTab: diseaseTab, onChange: onChangeDiseaseTab, diseaseTabClickReport: report.diseaseTabClickReport }),
            React.createElement(View, { className: styles['search-divider'] }),
            React.createElement(TranformButton, { moduleParams: report.cardReportModuleParams.module })),
        React.createElement(DiseaseModal, { disease: content, show: showModal, onHide: function () {
                setShowModal(false);
            }, diseaseModalExposure: report.diseaseModalExposure, diseaseTabClickReport: report.diseaseTabClickReport })));
};
export default DiseaseCard;
